const MUNNAR =
  'https://readdy.ai/api/search-image?query=Breathtaking%20realistic%20photograph%20of%20a%20lush%20Kerala%20tea%20estate%20in%20Munnar%20bathed%20in%20golden%20hour%20sunlight%2C%20rolling%20emerald%20green%20tea%20plantations%20on%20misty%20hillsides%2C%20soft%20warm%20morning%20mist%20over%20distant%20blue%20mountains%2C%20deep%20saturated%20natural%20greens%2C%20crisp%20high%20resolution%20landscape%20photography%2C%20true%20to%20life%2C%20serene%20and%20atmospheric&width=1600&height=1000&seq=globesync-munnar-hero&orientation=landscape';

export default function Hero() {
  return (
    <section
      className="relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden"
      id="top"
      style={{ paddingTop: '6rem' }}
    >
      {/* Static realistic background photograph */}
      <div className="absolute inset-0">
        <img
          src={MUNNAR}
          alt="Beautiful Kerala tea estate in Munnar - GlobeSync Travel Tour Packages"
          title="Munnar tea estate - GlobeSync Travel Tour Packages"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-foreground-950/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex w-full flex-col items-center px-4 py-28 text-center md:px-6 md:py-32">
        {/* Trust badge */}
        <div className="inline-flex items-center gap-2.5 rounded-full border border-background-50/40 bg-foreground-950/25 px-4 py-2 backdrop-blur-sm">
          <i className="ri-flight-takeoff-line text-accent-300" />
          <span className="text-xs font-medium tracking-wide text-background-50 md:text-sm">
            Serving Travelers Worldwide
          </span>
          <span className="h-3.5 w-px bg-background-50/40" />
          <span className="text-xs font-semibold tracking-wide text-accent-300 md:text-sm">
             Global Support
          </span>
        </div>

        {/* Headline */}
        <h1 className="mt-6 font-heading text-4xl font-bold leading-[1.05] tracking-tight text-background-50 md:mt-8 md:text-6xl lg:text-7xl">
          Your Global Journey,
          <span className="block text-accent-300">Simplified.</span>
        </h1>

        {/* Sub-headline */}
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/95 md:mt-8 md:text-lg">
          Curated national and international tour packages, expert visa assistance,
          worldwide flight bookings, and premium hotel reservations.
        </p>

        {/* CTA */}
        <div className="mt-8 flex flex-col items-center gap-3 md:mt-10 md:flex-row md:gap-4">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            Book Your Trip
            <i className="ri-arrow-right-line text-lg" />
          </a>
          <a
            href="#services"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/50 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-background-50/10"
          >
            Explore Services
          </a>
        </div>

        {/* Quick stats strip */}
        <div className="mt-12 grid w-full max-w-3xl grid-cols-1 gap-3 rounded-2xl border border-background-50/25 bg-foreground-950/30 p-5 backdrop-blur-sm sm:grid-cols-3 md:mt-16">
          {[
            { value: '190+', label: 'Clients served' },
            { value: '24/7', label: 'Global support' },
            { value: '100%', label: 'Visa guidance' },
          ].map((s) => (
            <div key={s.value} className="flex flex-col items-center justify-center gap-1 text-center">
              <span className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{s.value}</span>
              <span className="text-xs text-background-100/85 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-50/70">
        <span className="text-[11px] uppercase tracking-[0.25em]">Scroll</span>
        <i className="ri-arrow-down-line ml-1.5 align-middle" />
      </div>
    </section>
  );
}